// slices/UserManagementSlice.ts
import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface User {
  user_name: string;
  user_email: string;
}

interface UserManagementState {
  userListData: User[];
  assignedUsers: Record<string, string[]>;
}

const initialState: UserManagementState = {
  userListData: [],
  assignedUsers: {},
};

const userManagementSlice = createSlice({
  name: 'userManagement',
  initialState,
  reducers: {
    setUserListData: (state, action: PayloadAction<User[]>) => {
      state.userListData = action.payload;
    },
    assignUsersToRole: (state, action: PayloadAction<{ roleName: string, users: string[] }>) => {
      state.assignedUsers[action.payload.roleName] = action.payload.users;
    },
  },
});

export const { setUserListData, assignUsersToRole } = userManagementSlice.actions;
export default userManagementSlice.reducer;
